<template>
	<fs1-div>
		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="rows"
			class="tablaT1 tableALTH1"
			:class="dark_t?'dark':''">
      <template v-slot:headers="props">
				<tr>
					<th v-for="(th,i) in props.headers" :key="i">
						<div>
						<span>{{th.text}}</span>
						<fs1-tooltip v-if="th.tooltip">{{th.tooltip}}</fs1-tooltip>
						</div>
					</th>
				</tr>
      </template>
			<template v-slot:item="props">
				<tr>
					<td @click="selectAll(props.item)">
						<fs1-span>{{ props.item.name }}</fs1-span>
					</td>
					<td :class="getColor(props.item,'Compliance')" @click="select(props.item,'Compliance')" style="color:black">
						<fs1-span>{{ props.item.compliancesTotal }}%</fs1-span>
					</td>
					<td :class="getColor(props.item,'Cancelled')" @click="select(props.item,'Cancelled')" style="color:black">
						<fs1-span>{{ props.item.cancelledsTotal }}%</fs1-span>
					</td>
					<td :class="getColor(props.item,'Overdue')" @click="select(props.item,'Overdue')" style="color:black">
						<fs1-span>{{ props.item.overduesTotal }}%</fs1-span>
					</td>
				</tr>
			</template>
			<template v-slot:no-data>
				<v-icon>warning</v-icon>
				Sin Información.
			</template>
		</v-data-table>

	</fs1-div>
</template>

<script>

export default {
  props:{
		data:{},
		openModalTable:{
			default:()=>()=>{}
		}
	},
  data() {
    return {
			transComp:{
				Compliance:'compliancesTotal',
				Cancelled:'cancelledsTotal',
				Overdue:'overduesTotal',
			}
		};
  },
  computed: {
		dashboard_metrics_report_table() {return this.$store.getters.dashboard_metrics_report_table},
    headers() {
      return [
				{ text: 'Area', sortable: true , value: 'name', class:'text-xs-right',tooltip: 'Métricas: Se muestran las Ordenes de Trabajo preventivas (PM02) en cada uno de sus estados.'},
				{ text: 'Compliance', sortable: true , value: 'compliancesTotal' ,tooltip:'Ordenes de trabajo preventivas (PM02) ejecutadas en el periodo, dentro de la tolerancia + - 10%.'},
				{ text: 'Cancelled', sortable: true, value: 'cancelledsTotal', tooltip: 'Ordenes de Trabajo preventivas (PM02) canceladas en el periodo posterior a ser planificadas.'},
				{ text: 'Overdue',sortable: true, value: 'overduesTotal', tooltip: 'Número de Ordenes de Trabajo Preventivas (PM02) abiertas que están fuera de la tolerancia.' },
			];
    },
    rows() { return this.data },
  },
  methods: {
		selectAll(item) {
			this.openModalTable({organization:item.name},'current_month','Metrics');
		},
		select(item, pwo_type){
			this.openModalTable({organization:item.name,pwo_type},'current_month','Metrics');
		},

		getColor(r,key){		
			const item = this.dashboard_metrics_report_table.find(f => f.organization === r.name && f.pwo_type === key);
			if (!item) return '';
			const goal = item.min_goal.split(' ');
			const min_goal = parseInt(goal[1]);
			const toCompare = parseInt(item[/* key */'current_month']);
			if('>' === goal[0]) return toCompare > min_goal?'bg-green':'bg-red';
			if('>=' === goal[0]) return toCompare >= min_goal?'bg-green':'bg-red';
			if('<' === goal[0]) return toCompare < min_goal?'bg-green':'bg-red';
			if('<=' === goal[0]) return toCompare <= min_goal?'bg-green':'bg-red';
			return '';
		}
		
  }, // methods
};
</script>
